export default {
      id: "collapse-usage",
      viewBox: "0 0 10 14",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#collapse",
      toString: function () {
        return this.url;
      }
    }